module.exports = __webpack_public_path__ + "img/logo-en.fa2a50e.png";